// @flow
import { createSelector, Selector } from 'reselect';

import {
  parseMinutes,
  generateLabels,
  getMaxMinTime,
  getActualDaySchedule,
  getScheduleMarking
} from './schedule.model.js';

export const selectDatesType: () => Selector<ReduxState, void, Option[]> = type =>
  createSelector(
    state => state.instructor,
    instructor => {
      if (!instructor || !instructor.schedule || !Object.keys(instructor.schedule).length)
        return [];
      return Object.keys(instructor.schedule).reduce((acc, scheduleID) => {
        if (instructor.schedule[scheduleID].type === type) {
          return [...acc, instructor.schedule[scheduleID]];
        }
        return acc;
      }, []);
    }
  );

// ---------- HOUR LABELS ---------- //
export const selectHourLabels: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.user.settings.time,
  selectDatesType('week'),
  (timeFormat, weekTypeDates) => {
    const { min, max } = getMaxMinTime(weekTypeDates);
    return generateLabels(min || '00:00:00', max || '23:00:00', timeFormat);
  }
);

// ---------- DAYS OF WEEK ---------- //
export const selectDaysOfWeekSchedule: Selector<ReduxState, void, Option[]> = createSelector(
  selectDatesType('week'),
  weekTypeDates => {
    const { min } = getMaxMinTime(weekTypeDates);
    const globalStartTime = min ? parseMinutes(min) / 60 : 0;

    const normSchedule = weekTypeDates.reduce(
      (acc, date) => ({
        ...acc,
        [date.dayOfWeek]: getActualDaySchedule(date, acc[date.dayOfWeek])
      }),
      {}
    );
    return getScheduleMarking(normSchedule, globalStartTime);
  }
);

// ---------- ACCESSIBLE DATES ---------- //
export const selectAccessibleDates: Selector<ReduxState, void, Option[]> = createSelector(
  selectDatesType('date'),
  dates => dates.filter(date => date.accessType === 'accessible')
);

// ---------- NOT ACCESSIBLE DATES ---------- //
export const selectNotAccessibleDates: Selector<ReduxState, void, Option[]> = createSelector(
  selectDatesType('date'),
  dates => dates.filter(date => date.accessType === 'notAccessible')
);
